var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-input-file", style: _vm.style }, [
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasFile || _vm.deleble,
            expression: "hasFile || deleble"
          }
        ],
        staticClass: "delete",
        on: { click: _vm.removeImage }
      },
      [_vm._v("X")]
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "input",
      attrs: { type: "file", name: _vm.name, id: _vm.id },
      on: { change: _vm.onFileChange }
    }),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.hasFile && _vm.isImage,
          expression: "hasFile && isImage"
        }
      ],
      staticClass: "img-loaded",
      attrs: { id: "img-preview-" + _vm.id, src: _vm.imgPreview }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hasFile && !_vm.isImage,
            expression: "hasFile && !isImage"
          }
        ]
      },
      [
        _c("i", {
          staticClass: "fa",
          class: _vm.fontawesomeIconNoImage,
          staticStyle: { "padding-top": "5px", "font-size": "6em" }
        })
      ]
    ),
    _vm._v(" "),
    !_vm.hasFile
      ? _c(
          "p",
          { staticStyle: { padding: "0px 5px" } },
          [
            _c("i", { staticClass: "fa fa-upload" }),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasFile
      ? _c(
          "div",
          {
            staticClass: "download text-primary",
            on: { click: _vm.downloadFile }
          },
          [
            _c("i", { staticClass: "fa fa-download" }),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e029a860", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e029a860","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/InputFile.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e029a860","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/InputFile.vue
// module chunks = 2